import config from './config'

export const CREATE_TEMPLATE = `${config.API}vcs/v1/vcs/createTemplate`
export const GET_TEMPLATE_LIST = `${config.API}vcs/v1/vcs/searchTemplate`
export const GET_TEMPLATE = `${config.API}vcs/v1/vcs/getTemplate`

export const GET_TASK_LIST = `${config.API}vcs/v1/vcs/searchTask`
export const GET_TASK = `${config.API}vcs/v1/vcs/getTask`
export const CREATE_TASK = `${config.API}vcs/v1/vcs/createTask`
export const CREATE_FACTORY = `${config.API}vcs/v1/vcs/createFactory`

export const UPLOAD_URL = `${config.API}vcs/v1/upload`
